import React, { useMemo } from 'react';
import classNames from 'classnames';
import SelectCustomOptions from 'components/SelectCustomOptions';
import { ExtractPropTypes } from 'types';
import { FieldRenderProps } from 'react-final-form';
import FieldWrapper from 'components/FieldWrapper';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';

import './SelectCustomOptionsField.styles.scss';

type SelectComponentProps = ExtractPropTypes<typeof SelectCustomOptions>;

export type SelectCustomOptionsFieldProps = FieldWrapperProps &
  SelectComponentProps &
  FieldRenderProps<string, HTMLElement>;

const SelectCustomOptionsField: React.FC<SelectCustomOptionsFieldProps> = (
  props,
) => {
  const {
    input: { onChange, ...restInput },
    meta: { touched, error },
    className,
    options,
    ...rest
  } = props;

  const hasError = useMemo(() => touched && error, [error, touched]);

  const classes = classNames('select-custom-options-field', className);

  return (
    <FieldWrapper
      className={classes}
      error={error}
      hasError={hasError}
      {...rest}
    >
      <SelectCustomOptions
        {...rest}
        {...restInput}
        hasError={hasError}
        options={options}
        onChange={onChange}
      />
    </FieldWrapper>
  );
};

export default SelectCustomOptionsField;
